import { Star } from "lucide-react";

export const APP_TERMINAL = ["Rejected", "Dropped", "Hired"];

export function RatingStars({ value, size = 12 }) {
  if (!value) return <span className="text-[10px] text-[#6B7280]">—</span>;
  return (
    <span className="inline-flex items-center gap-0.5 text-[#BF9B30]">
      {[1, 2, 3, 4, 5].map((i) => (
        <Star key={i} size={size} fill={i <= Math.round(value) ? "currentColor" : "none"} strokeWidth={1.5} />
      ))}
      <span className="ml-1 text-[10px] text-[#6B7280] tabular-nums">{value}</span>
    </span>
  );
}

export function SourceChip({ source }) {
  return (
    <span className="inline-block border border-gray-300 text-[#6B7280] px-1.5 py-0.5 text-[10px] uppercase tracking-wide rounded-sm whitespace-nowrap">
      {source}
    </span>
  );
}

const APP_STATUS_CLS = {
  Active: "text-[#1B7F3B] border-[#1B7F3B]/40 bg-[#1B7F3B]/5",
  "On Hold": "text-[#6B7280] border-gray-400 bg-gray-100",
  Rejected: "text-[#BB162B] border-[#BB162B]/40 bg-[#BB162B]/5",
  Dropped: "text-[#D97706] border-[#D97706]/40 bg-[#D97706]/5",
  Hired: "text-white border-[#1B7F3B] bg-[#1B7F3B]",
};

export function AppStatusBadge({ status }) {
  return (
    <span className={`inline-block border px-2 py-0.5 text-[11px] font-medium rounded-sm whitespace-nowrap ${APP_STATUS_CLS[status] || APP_STATUS_CLS.Active}`}>
      {status}
    </span>
  );
}

export function StarPicker({ value, onChange, size = 28, testid }) {
  return (
    <div className="flex items-center gap-1.5" data-testid={testid}>
      {[1, 2, 3, 4, 5].map((i) => (
        <button key={i} type="button" data-testid={`${testid}-${i}`} onClick={() => onChange(i)}
          className={`transition-transform duration-150 active:scale-90 ${i <= value ? "text-[#BF9B30]" : "text-gray-300"}`}>
          <Star size={size} fill={i <= value ? "currentColor" : "none"} strokeWidth={1.5} />
        </button>
      ))}
    </div>
  );
}

export function downloadBlob(data, filename) {
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  a.click();
  URL.revokeObjectURL(url);
}
